var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sTooltip',{attrs:{"border":false,"content":_vm.$t('Tenders.Winner'),"data-qa":"bidder-is-winner-tooltip","placement":"bottom","type":"white"}},[_c('sIcon',{staticClass:"bidder-is-winner",attrs:{"color":_vm.color,"data-qa":"bidder-is-winner","size":"12","type":"person-check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }